// Generated by ReScript, PLEASE EDIT WITH CARE


function toVarinat(trip_type, data) {
  switch (trip_type) {
    case "additional_charges" :
        return {
                TAG: /* AdditionCharges */5,
                _0: data
              };
    case "coupon_discount" :
        return {
                TAG: /* CouponDiscount */3,
                _0: data
              };
    case "gst_charges" :
        return {
                TAG: /* GSTCharges */6,
                _0: data
              };
    case "labour_charge" :
        return {
                TAG: /* LabourCharges */4,
                _0: data
              };
    case "package_charge" :
        return {
                TAG: /* PackageCharge */1,
                _0: data
              };
    case "porter_gold_savings" :
        return {
                TAG: /* PorterGoldSavings */2,
                _0: data
              };
    case "trip_fare" :
        return {
                TAG: /* TripFare */0,
                _0: data
              };
    case "vat" :
        return {
                TAG: /* VAT */7,
                _0: data
              };
    default:
      return /* None */0;
  }
}

export {
  toVarinat ,
  
}
/* No side effect */
